/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "../../generated/types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimatePricesQueryVariables = Types.Exact<{
	input: Types.EstimatePricesInput;
}>;

export type EstimatePricesQuery = {
	__typename?: "Query";
	estimatePrices: {
		__typename?: "PriceEstimationResponse";
		price: string;
		appropriatenessTest: { __typename?: "AppropriatenessTest"; required: boolean; warning: boolean };
		min: { __typename?: "AssetFiatRange"; asset: string; fiat: string };
		max: { __typename?: "AssetFiatRange"; asset: string; fiat: string };
	};
};

export const EstimatePricesDocument = gql`
	query estimatePrices($input: EstimatePricesInput!) {
		estimatePrices(input: $input) {
			price
			appropriatenessTest {
				required
				warning
			}
			min {
				asset
				fiat
			}
			max {
				asset
				fiat
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimatePricesGQLService extends Apollo.Query<EstimatePricesQuery, EstimatePricesQueryVariables> {
	document = EstimatePricesDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
